import { uploadData } from '@aws-amplify/storage';

const PutStories = async ( storyid, file) => {
  try {
    const result = await uploadData({
      path: ({ identityId }) => `private/${identityId}/stories/${storyid}.json`,
      // Alternatively, path: ({identityId}) => `album/${identityId}/1.jpg`
      data: file
    });
    return result;
  } catch (error) {
    console.error("Error:", error);
    return [];
  }
};

export default PutStories;


// If you want to monitor progress include below
    //   options: {  
    //     onProgress: ({ transferredBytes, totalBytes }) => {
    //       if (totalBytes) {
    //         console.log(
    //           `Upload progress ${Math.round(
    //             (transferredBytes / totalBytes) * 100
    //           )} %`
    //         );
    //       }
    //     },
    //   },